import dayjs from "dayjs";
import { ISettings } from "./Models";

let currentSettings: ISettings;
const language = document?.documentElement.lang.indexOf("sv") >= 0 ? "sv-SE" : "en-GB";

export const currentLanguage = language;

export const updateSettings = (settings: ISettings) => {
	currentSettings = settings;
};

export const updateAccessToken = (accessToken: string, expires: string) => {
	console.debug("updateAccessToken", accessToken, expires);
	currentSettings = { ...currentSettings, ...{ token: { accessToken, expires } }};
};

export const getSettings = () => {
	return currentSettings;
};

export const getDefaultHeaders = () => {
	return {
		"Accept": "application/json",
		"Accept-Language": language,
		"Content-Type": "application/json",
		"Authorization": `Bearer ${currentSettings.token?.accessToken}`
	};
};

export const getAccessToken = async () => {
	const response = await fetch("/token/v2", {
		method: "GET",
		credentials: "same-origin",
		headers: {
			"Accept": "application/json",
			"Accept-Language": language,
			"Content-Type": "application/json"
		}
	});

	if (response.ok) {
		var token = await response.json();
		updateAccessToken(token.access_token, dayjs().add(token.expires_in, "seconds").format("YYYY-MM-DD HH:mm:ss"));
		// console.debug("Retrieved api token", token);
		return true;
	}

	console.error("Could not get api token");
	updateAccessToken("", null);
	return false;
};

export const refreshAccessToken = async () => {
	const response = await fetch(`${currentSettings.apiUrl}/auth/refreshtoken`, {
		method: "POST",
		credentials: "same-origin",
		headers: getDefaultHeaders()
	});

	if (response.ok) {
		var token = await response.json();
		updateAccessToken(token.access_token, dayjs().add(token.expires_in, "seconds").format("YYYY-MM-DD HH:mm:ss"));
		console.debug("Updated api token", token);
	}
	else if (response.status === 401)
	{
		alert("Din session har gått ut, sidan måste laddas om");
		window.location.reload();
	}
};

export const travelMethodIcons = {
	"LONG_DISTANCE_TRAINS": "train",
	// "F": "boat",	//Färja
	"BUS": "bus",		//Buss
	"SLEEPER_RAIL_SERVICE": "train",
	// "U": "train",	//Tunnelbana
	"G": "walk",	//Gå
	// "X": "bus",		//Stadstrafik
	// "T": "taxi"		//Taxi
} as { [code: string]: string };

export const getTravelMethodIcon = (modality: string) => travelMethodIcons[modality];
export const getTravelMethodText = (_: string) => null; //TODO...

export const travelMethodClass = (modality?: string) => {
	const travelMethodIcon = getTravelMethodIcon(modality);
	return travelMethodIcon ? `travelmethod-icon-${travelMethodIcon}` : null;
};